<div class="line-chart">
  <svg [attr.width]="width" [attr.height]="height" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path *ngFor="let item of plannedData"
            [attr.d]="item" fill="none"
            stroke="#aaa" stroke-dasharray="2,4" stroke-width="1">
      </path>

      <path *ngFor="let item of currentData.lines"
            [attr.d]="item" fill="none"
            stroke="#f3f4f6" stroke-width="10">
      </path>

      <path *ngFor="let item of currentData.lines"
            [attr.d]="item" fill="none"
            stroke="#2eadde" stroke-width="2">
      </path>

      <circle class="sector-point" *ngFor="let item of currentData.points" (click)="selectPoint(item)"
              [attr.cx]="item.x" [attr.cy]="item.y" r="4"
              stroke="#2eadde" stroke-width="3" fill="white"></circle>

      <circle [attr.cx]="currentData.center.x" [attr.cy]="currentData.center.y" r="16"
              stroke="#5c4bb5" stroke-width="5" fill="white"></circle>

      <circle [attr.cx]="currentData.center.x" [attr.cy]="currentData.center.y" r="5"
              stroke="#5c4bb5" stroke-width="0" fill="#5c4bb5"></circle>

      <text *ngFor="let item of currentData.annotations"
            [attr.x]="item.x" [attr.y]="item.y"
            style="stroke:white; stroke-width:0.3em"
            fill="#7d7d7d" font-family="Arial" font-size="fontSize">
        {{item.annotation}}
      </text>

      <text *ngFor="let item of currentData.annotations" font-size="fontSize"
            [attr.x]="item.x" [attr.y]="item.y" fill="#7d7d7d" font-family="Arial">
        <title>{{item.fullAnnotation}}</title>
        {{item.annotation}}
      </text>
    </g>
    <g>
      <g *ngIf="imageGroupPosition=='left'">
        <image *ngIf="imagePath"
               [attr.xlink:href]="imagePath"
               [attr.x]="0"
               [attr.y]="preparedCenter.y - imageWidth - 25"
               [attr.width]="imageWidth"
               [attr.height]="imageWidth">
        </image>
        <text *ngIf="animationFinished" font-size="60px" fill="#5c4bb5"
              font-family="Arial" font-weight="600"
              [attr.x]="imageWidth"
              [attr.y]="preparedCenter.y - 25">
          <title>{{value + ', ' + title}}</title>
          {{preparedValue}}
        </text>

        <g *ngIf="!animationFinished">
          <text font-size="60px" fill="#5c4bb5"
                font-family="Arial" font-weight="600"
                [attr.x]="imageWidth + 10"
                [attr.y]="preparedCenter.y - 25">
            <title>{{value + ', ' + title}}</title>
            {{animationPrefix}}
          </text>
          <text id="step1"
                font-size="60px" fill="#5c4bb5"
                font-family="Arial" font-weight="600"
                [attr.x]="imageWidth + animationPrefixLength + 10"
                [attr.y]="preparedCenter.y - 75">
            {{generatedCharacter}}
          </text>
          <text id="step2"
                font-size="60px" fill="#5c4bb5"
                font-family="Arial" font-weight="600"
                [attr.x]="imageWidth + animationPrefixLength + 10"
                [attr.y]="preparedCenter.y - 75">
            {{generatedCharacter}}
          </text>
          <text id="step3"
                font-size="60px" fill="#5c4bb5"
                font-family="Arial" font-weight="600"
                [attr.x]="imageWidth + animationPrefixLength + 10"
                [attr.y]="preparedCenter.y - 75">
            {{generatedCharacter}}
          </text>
        </g>

        <text *ngIf="animationFinished" font-size="16px"
              [attr.x]="valueWidth + imageWidth + 20"
              [attr.y]="preparedCenter.y - 30"
              fill="#392f6e">
          <title>{{value + ', ' + title}}</title>
          {{preparedTitle}}
        </text>
        <line stroke="#392f6e" stroke-dasharray="4,4" stroke-width="2"
              [attr.x1]="0"
              [attr.y1]="preparedCenter.y"
              [attr.x2]="preparedCenter.x"
              [attr.y2]="preparedCenter.y">
        </line>
        <text *ngFor="let description of descriptions; let i=index" font-size="15px" font-family="Arial"
              [attr.x]="0" [attr.y]="preparedCenter.y + 20*(i+1)" fill="#717171">
          <title>{{description}}</title>
          {{description}}
        </text>
      </g>
      <g *ngIf="imageGroupPosition=='right'">
        <image *ngIf="imagePath"
               [attr.xlink:href]="imagePath"
               [attr.x]="width - (imageWidth + valueWidth + titleWidth + 20)"
               [attr.y]="preparedCenter.y - imageWidth -25"
               [attr.height]="imageWidth"
               [attr.width]="imageWidth">
        </image>
        <text *ngIf="animationFinished" font-size="60px" fill="#5c4bb5" font-family="Arial" font-weight="600"
              [attr.x]="width - (valueWidth + titleWidth) - 5"
              [attr.y]="preparedCenter.y - 25">
          <title>{{value + ', ' + title}}</title>
          {{preparedValue}}
        </text>
        <g *ngIf="!animationFinished">
          <text font-size="60px" fill="#5c4bb5"
                font-family="Arial" font-weight="600"
                [attr.x]="width - (valueWidth + titleWidth + 10)"
                [attr.y]="preparedCenter.y - 25">
            <title>{{value + ', ' + title}}</title>
            {{animationPrefix}}
          </text>
          <text id="step1"
                font-size="60px" fill="#5c4bb5"
                font-family="Arial" font-weight="600"
                [attr.x]="width - (valueWidth + titleWidth + 10) + animationPrefixLength"
                [attr.y]="preparedCenter.y - 75">
            {{generatedCharacter}}
          </text>
          <text id="step2"
                font-size="60px" fill="#5c4bb5"
                font-family="Arial" font-weight="600"
                [attr.x]="width - (valueWidth + titleWidth + 10) + animationPrefixLength"
                [attr.y]="preparedCenter.y - 75">
            {{generatedCharacter}}
          </text>
          <text id="step3"
                font-size="60px" fill="#5c4bb5"
                font-family="Arial" font-weight="600"
                [attr.x]="width - (valueWidth + titleWidth + 10) + animationPrefixLength"
                [attr.y]="preparedCenter.y - 75">
            {{generatedCharacter}}
          </text>
        </g>

        <text *ngIf="animationFinished" font-size="16px"
              [attr.x]="width - (titleWidth + 5)"
              [attr.y]="preparedCenter.y - 30"
              fill="#392f6e">
          <title>{{value + ', ' + title}}</title>
          {{preparedTitle}}
        </text>
        <line stroke="#392f6e" stroke-dasharray="4,4" stroke-width="2"
              [attr.x1]="preparedCenter.x"
              [attr.y1]="preparedCenter.y"
              [attr.x2]="width"
              [attr.y2]="preparedCenter.y">
        </line>
        <text *ngFor="let description of descriptions; let i=index" font-size="15px" font-family="Arial"
              [attr.x]="width - (imageWidth + valueWidth + titleWidth + 20)"
              [attr.y]="preparedCenter.y + 20*(i+1)" fill="#717171">
          <title>{{description}}</title>
          {{description}}
        </text>
      </g>
      <g *ngIf="imageGroupPosition=='top'">
        <g [attr.transform]='transformImage'>

          <image *ngIf="imagePath"
                 [attr.xlink:href]="imagePath"
                 [attr.x]="preparedCenter.x - (imageWidth + 10)"
                 [attr.y]="(preparedCenter.y - padding)/2 - imageWidth - 15"
                 [attr.height]="imageWidth"
                 [attr.width]="imageWidth">
          </image>
          <text *ngIf="animationFinished" font-size="60px" fill="#5c4bb5" font-family="Arial" font-weight="600"
                [attr.x]="preparedCenter.x"
                [attr.y]="(preparedCenter.y - padding)/2 - 15">
            <title>{{value + ', ' + title}}</title>
            {{preparedValue}}
          </text>

          <g *ngIf="!animationFinished">
            <text font-size="60px" fill="#5c4bb5"
                  font-family="Arial" font-weight="600"
                  [attr.x]="preparedCenter.x + 10"
                  [attr.y]="(preparedCenter.y - padding)/2 - 15">
              <title>{{value + ', ' + title}}</title>
              {{animationPrefix}}
            </text>
            <text id="step1"
                  font-size="60px" fill="#5c4bb5"
                  font-family="Arial" font-weight="600"
                  [attr.x]="preparedCenter.x + 10 + animationPrefixLength"
                  [attr.y]="(preparedCenter.y - padding)/2 - 65">
              {{generatedCharacter}}
            </text>
            <text id="step2"
                  font-size="60px" fill="#5c4bb5"
                  font-family="Arial" font-weight="600"
                  [attr.x]="preparedCenter.x + 10 + animationPrefixLength"
                  [attr.y]="(preparedCenter.y - padding)/2 - 65">
              {{generatedCharacter}}
            </text>
            <text id="step3"
                  font-size="60px" fill="#5c4bb5"
                  font-family="Arial" font-weight="600"
                  [attr.x]="preparedCenter.x + 10 + animationPrefixLength"
                  [attr.y]="(preparedCenter.y - padding)/2 - 65">
              {{generatedCharacter}}
            </text>
          </g>

          <text *ngIf="animationFinished" font-size="16px"
                [attr.x]="preparedCenter.x + valueWidth + 15"
                [attr.y]="(preparedCenter.y - padding)/2 - 20 - 20*descriptions.length"
                fill="#392f6e">
            <title>{{value + ', ' + title}}</title>
            {{preparedTitle}}
          </text>
          <g *ngIf="animationFinished">
            <text *ngFor="let description of descriptions; let i=index" font-size="15px" font-family="Arial"
                  [attr.x]="preparedCenter.x + valueWidth + 20"
                  [attr.y]="(preparedCenter.y - padding)/2 + 5 - 20*(descriptions.length - i)" fill="#717171">
              <title>{{description}}</title>
              {{description}}
            </text>
          </g>
        </g>
        <line stroke="#392f6e" stroke-dasharray="4,4" stroke-width="2"
              [attr.x1]="preparedCenter.x"
              [attr.y1]="preparedCenter.y"
              [attr.x2]="preparedCenter.x"
              [attr.y2]="(preparedCenter.y - padding)/2">
        </line>
      </g>
      <g *ngIf="imageGroupPosition=='bottom'">
        <g [attr.transform]='transformImage'>
          <image *ngIf="imagePath"
                 [attr.xlink:href]="imagePath"
                 [attr.x]="preparedCenter.x - (imageWidth + 10)"
                 [attr.y]="(preparedCenter.y + (height - preparedCenter.y)/2) + 15"
                 [attr.height]="imageWidth"
                 [attr.width]="imageWidth">
          </image>
          <text *ngIf="animationFinished" font-size="60px" fill="#5c4bb5" font-family="Arial" font-weight="600"
                [attr.x]="preparedCenter.x"
                [attr.y]="(preparedCenter.y + (height - preparedCenter.y)/2) + 60">
            <title>{{value + ', ' + title}}</title>
            {{preparedValue}}
          </text>

          <g *ngIf="!animationFinished">
            <text font-size="60px" fill="#5c4bb5"
                  font-family="Arial" font-weight="600"
                  [attr.x]="preparedCenter.x + 10"
                  [attr.y]="(preparedCenter.y + (height - preparedCenter.y)/2) + 60">
              <title>{{value + ', ' + title}}</title>
              {{animationPrefix}}
            </text>
            <text id="step1"
                  font-size="60px" fill="#5c4bb5"
                  font-family="Arial" font-weight="600"
                  [attr.x]="preparedCenter.x + 10 + animationPrefixLength"
                  [attr.y]="(preparedCenter.y + (height - preparedCenter.y)/2) + 10">
              {{generatedCharacter}}
            </text>
            <text id="step2"
                  font-size="60px" fill="#5c4bb5"
                  font-family="Arial" font-weight="600"
                  [attr.x]="preparedCenter.x + 10 + animationPrefixLength"
                  [attr.y]="(preparedCenter.y + (height - preparedCenter.y)/2) + 10">
              {{generatedCharacter}}
            </text>
            <text id="step3"
                  font-size="60px" fill="#5c4bb5"
                  font-family="Arial" font-weight="600"
                  [attr.x]="preparedCenter.x + 10 + animationPrefixLength"
                  [attr.y]="(preparedCenter.y + (height - preparedCenter.y)/2) + 10">
              {{generatedCharacter}}
            </text>
          </g>

          <text *ngIf="animationFinished" font-size="16px"
                [attr.x]="preparedCenter.x + valueWidth + 15"
                [attr.y]="(preparedCenter.y + (height - preparedCenter.y)/2) + 30"
                fill="#392f6e">
            <title>{{value + ', ' + title}}</title>
            {{preparedTitle}}
          </text>
          <g *ngIf="animationFinished">
            <text *ngFor="let description of descriptions; let i=index" font-size="15px" font-family="Arial"
                  [attr.x]="preparedCenter.x + valueWidth + 20"
                  [attr.y]="(preparedCenter.y + (height - preparedCenter.y)/2) + 30 + 20*(i+1)" fill="#717171">
              <title>{{description}}</title>
              {{description}}
            </text>
          </g>
        </g>

        <line stroke="#392f6e" stroke-dasharray="4,4" stroke-width="2"
              [attr.x1]="preparedCenter.x"
              [attr.y1]="preparedCenter.y"
              [attr.x2]="preparedCenter.x"
              [attr.y2]="(preparedCenter.y + (height - preparedCenter.y)/2)">
        </line>
      </g>
    </g>
  </svg>
</div>
